<template>
  <header class="header">
    <div class="company-info">
      <div>Employees: {{ allEmployeeCount }}</div>
    </div>
    <div class="control-bar">
      <div class="control-bar__tick tick">
        <div class="tick__info">Tick: {{ tick }}</div>
        <button
          v-if="!tickInterval"
          class="start"
          @click="startTickInterval"
        >
          START
        </button>
        <button
          v-if="tickInterval"
          class="stop"
          @click="clearTickInterval"
        >
          STOP
        </button>
      </div>
      <div>
        <span>Create a team</span>
        <ButtonCreateTeam
          v-for="teamType in TYPE_TEAMS"
          :key="teamType"
          :teamType="teamType"
        />
      </div>
    </div>
  </header>
</template>

<script>
import { TYPE_TEAMS } from '@/constants';
import { mapState, mapMutations, mapGetters } from 'vuex';
import ButtonCreateTeam from '@/components/ButtonCreateTeam.vue';

export default {
  name: 'Header',
  components: {
    ButtonCreateTeam,
  },
  data() {
    return {
      TYPE_TEAMS,
    };
  },
  computed: {
    ...mapState([
      'tick',
      'tickInterval',
    ]),
    ...mapGetters(['allEmployeeCount']),
  },
  methods: {
    ...mapMutations([
      'startTickInterval',
      'clearTickInterval',
    ]),
  },
};
</script>

<style lang="less" scoped>
.header {
  grid-area: header;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}

.control-bar {
  display: flex;
  justify-content: space-evenly;
  margin: 0 0 0 auto;
  span + button {
    margin-left: 10px;
  }
  &__tick {
    display: flex;
    margin: 0 40px 0 0;
    button {
      color: #fff;
      + button {
        margin-left: 10px;
      }
      &.start {
        background-color: #81CC45;
      }
      &.stop {
        background-color: #F26B5B;
      }
    }
  }
}

.tick {
  &__info {
    margin: 0 10px 0 0;
  }
}

</style>
